module.exports = __webpack_public_path__ + "img/Eyes 180.21f83815.png";